import clinicAPI from "../services/clinicApi";

/**
 * Creates default direction + venue if missing so the user can start
 * from «Группа» without separate guided steps.
 * @param {{ directionName?: string }} [opts]
 */
export async function ensureQuickStartDefaults(opts = {}) {
  const directionName =
    String(opts.directionName || "").trim() || "Спорт";

  const status = await clinicAPI.getClinicSetupStatus().catch(() => null);
  const needsDirection = !(Number(status?.directions_count) > 0);
  const needsVenue = !(Number(status?.branches_count) > 0);

  if (!needsDirection && !needsVenue) {
    return { created: false, status };
  }

  if (needsDirection) {
    await clinicAPI.createSportDirection({ name: directionName });
  }
  if (needsVenue) {
    await clinicAPI.createBranch({
      name: "Основной зал",
      is_default: true,
    });
  }

  const next = await clinicAPI.getClinicSetupStatus().catch(() => status);
  return { created: true, status: next };
}
